import Vue from 'vue';
import store from './store';
import WidgetExample from './widgets/WidgetExample.vue';
import Listing from './components/blocks/Listing/index.vue';
import Compare from './components/blocks/Compare/Compare.vue';
import Wishlist from './components/blocks/Wishlist/index.vue';
import List from './components/blocks/List/index.vue';
import Single from './components/blocks/Single/index.vue';
import ProductSlider from './components/blocks/ProductSlider/index.vue';
import advancedSearch from './components/blocks/AdvancedSearch/index.vue';

const createNewVueInstance = function(id, component, store) {
    if (document.getElementById(id)) {
        // eslint-disable-next-line no-new
        new Vue({
            el: `#${id}`,
            render: createEl => createEl(component),
            store
        });
    }
};

// create an example block
createNewVueInstance('vue-example-block', WidgetExample, store);
createNewVueInstance('listing', Listing, store);
createNewVueInstance('page-compare-vue', Compare, store);
createNewVueInstance('page-wishlist-vue', Wishlist, store);
createNewVueInstance('page-single-wishlist-vue', List, store);
createNewVueInstance('advancedSearch', advancedSearch, store);
createNewVueInstance('singleProductSlider', ProductSlider, store);
if (kadraGlobal.userId !== '0' && usingcustomer.session.type !== 'salesman') {
    createNewVueInstance('single-add-to-list', Single, store);
}

if (document.getElementById('productSlider')) {
    // eslint-disable-next-line no-new
    window.VueProductSlider = new Vue({
        el: '#productSlider',
        render: createEl => createEl(ProductSlider),
        store
    });
}
